import { IDashboardSettings, PreferenceType, PreferencesContext } from "components/preferences";
import { useContext, useEffect, useState } from "react";

export type SetPreferenceSignature = (value: IDashboardSettings) => void;

type UsePreferenceResult = [
    boolean,
    IDashboardSettings | null,
    SetPreferenceSignature
]

type UsePreferenceSignature = (type: PreferenceType, usePesist?: boolean) => UsePreferenceResult;

const usePreference: UsePreferenceSignature = (type, usePesist = true) => {
    const preferences = useContext(PreferencesContext);
    const [ value, setValue ] = useState<IDashboardSettings | null>(null);

    useEffect(() => {
        if (!usePesist) return;
        if (preferences === null || !preferences.loaded) return;
        
        const index = preferences.data.preferences.findIndex(p => p.id == type);
        if (index != -1) {
            const result = preferences.data.preferences[index];
            setValue(result.settings);
        }
    }, [ preferences, type ]);

    const savePreference: SetPreferenceSignature = (newValue) => {     
        if (!usePesist) return;   
        if (preferences == null || preferences.loaded == false) return;
        
        preferences.setPreference({
            id: type,
            settings: newValue
        });

        setValue(newValue);
    };

    return [
        preferences?.loaded || false,
        value,
        savePreference
    ];
};

export default usePreference;